export const floatBtn = {
  floatBtnWithdrawl: "Onttrekking",
  floatBtnDeposit: "Deponeer",
};
